import "./index.css";
"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _merge = _interopRequireDefault(require("lodash/merge"));

var _component = require("../_utils/component");

var _popper = _interopRequireDefault(require("popper.js"));

var _popupManager = _interopRequireDefault(require("../_utils/popup-manager"));

var _dom = require("../_utils/dom");

var _eventemitter = _interopRequireDefault(require("eventemitter3"));

var _vueNormalizeComponent = _interopRequireDefault(require("../_utils/vue-normalize-component.js"));

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var popperJs = 'POPPERJS';
var eventBus = new _eventemitter.default();
var __vue_script__ = {
  name: (0, _component.createComponentName)('popover'),
  mixins: [_component.componentMixin],

  update() {
    eventBus.emit('update');
  },

  props: {
    tag: {
      type: [String, Object],
      default: 'span'
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    animation: {
      type: [Object, String],
      default: 'gd-fade'
    },
    popoverClass: {
      type: [String, Array],
      default: ''
    },
    fixed: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean
    },
    // 主题色
    theme: {
      // 'dark' / ‘light’
      type: String,
      default: 'light'
    },
    arrow: {
      type: Boolean,
      default: true
    },
    defaultVisible: {
      type: Boolean,
      default: false
    },
    lazy: {
      type: Boolean,
      default: true
    },
    trigger: {
      type: String,
      default: 'hover',
      validator: function validator(value) {
        return ['click', 'hover', 'focus'].indexOf(value) > -1;
      }
    },
    placement: {
      type: String,
      default: 'bottom'
    },
    // 延迟多久消失
    delayonMouseLeave: {
      type: Number,
      default: 50
    },
    // 延迟多久显示
    delayonMouseEnter: {
      type: Number,
      default: 0
    },
    modifiers: {
      type: Object,
      default: function _default() {}
    }
  },

  data() {
    var visible = false;
    if (this.$hasProp('visible')) visible = this.visible;else if (this.$hasProp('defaultVisible')) visible = this.defaultVisible;
    return {
      isShowPopper: visible,
      zIndex: 0,
      hasShow: visible,
      mounted: false
    };
  },

  watch: {
    isShowPopper(value) {
      if (value) this.hasShow = true;

      if (value) {
        this.$emit('show');

        _popupManager.default.pushStack(this);

        this.updatePopper();
      } else {
        this.$emit('hide');
      }
    },

    visible(value) {
      this.isShowPopper = value;
    }

  },

  mounted() {
    if (this.$isServer) return;
    eventBus.on('update', this.updatePopper);
    this.eventsEnabled = true;
    this.mounted = true;
    this.initReferenceEvent();

    if (this.appendToBody && this.$refs.content) {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    }

    if (this.isShowPopper) {
      _popupManager.default.pushStack(this);

      this.createPopper();
    }
  },

  beforeDestroy() {
    eventBus.off('update', this.updatePopper);
    this.offReferenceEvent();
    this.doDestroy();
  },

  methods: {
    afterLeave() {
      _popupManager.default.popStack(this);

      this.$emit('after-leave');
    },

    doDestroy() {
      this.offPopperEvent();

      if (this[popperJs]) {
        this[popperJs].destroy();
        this[popperJs] = null;
      }

      if (this.appendToBody && this.appendedToBody && this.$refs.content) {
        this.appendedToBody = false;
        document.body.removeChild(this.$refs.content);
      }
    },

    initReferenceEvent() {
      switch (this.trigger) {
        case 'click':
          (0, _dom.on)(this.$el.children[0], 'click', this.onClick);
          (0, _dom.on)(document, 'click', this.handleDocumentClick);
          break;

        case 'hover':
          (0, _dom.on)(this.$el.children[0], 'mouseenter', this.onMouseEnter);
          (0, _dom.on)(this.$el.children[0], 'mouseleave', this.onMouseLeave);
          break;

        case 'focus':
          (0, _dom.on)(this.$el.children[0], 'focus', this.onMouseEnter);
          (0, _dom.on)(this.$el.children[0], 'blur', this.onMouseLeave);
          break;
      }
    },

    initPopperEvent() {
      switch (this.trigger) {
        case 'hover':
          (0, _dom.on)(this.$refs.content, 'mouseenter', this.onContentMouseEnter);
          (0, _dom.on)(this.$refs.content, 'mouseleave', this.onContentMouseLeave);
          (0, _dom.on)(this.$refs.content, 'focus', this.onMouseEnter);
          (0, _dom.on)(this.$refs.content, 'blur', this.onMouseLeave);
          break;
      }
    },

    offReferenceEvent() {
      switch (this.trigger) {
        case 'click':
          (0, _dom.off)(document, 'click', this.handleDocumentClick);
          break;
      }
    },

    offPopperEvent() {
      (0, _dom.off)(this.$refs.content, 'mouseenter', this.onContentMouseEnter);
      (0, _dom.off)(this.$refs.content, 'mouseleave', this.onContentMouseLeave);
      (0, _dom.off)(this.$refs.content, 'focus', this.onMouseEnter);
      (0, _dom.off)(this.$refs.content, 'blur', this.onMouseLeave);
    },

    changeVisible(value) {
      if (this.$hasProp('visible')) {
        this.$emit('update:visible', value);
      } else {
        this.isShowPopper = value;
      }
    },

    doToggle() {
      if (!this.forceShow) {
        this.updatePopper();
        this.changeVisible(!this.isShowPopper);
      }
    },

    onClick() {
      this.updatePopper();
      this.changeVisible(!this.isShowPopper);
    },

    onContentMouseEnter() {
      this.mouseInContent = true;
    },

    onContentMouseLeave() {
      this.mouseInContent = false;
      this.changeVisible(false);
    },

    onMouseEnter() {
      var _this = this;

      clearTimeout(this._timer);
      this._timer = setTimeout(function () {
        if (_this.isShowPopper === true || _this.leaveing) return;

        _this.updatePopper();

        _this.changeVisible(true);
      }, this.delayonMouseEnter);
    },

    onMouseLeave() {
      var _this2 = this;

      clearTimeout(this._timer);
      this._timer = setTimeout(function () {
        if (_this2.mouseInContent) return;

        _this2.changeVisible(false);
      }, this.delayonMouseLeave);
    },

    handleDocumentClick(e) {
      if (!this.$el || this.elementContains(this.$el, e.target) || !this.$refs.content || this.elementContains(this.$refs.content, e.target)) {
        return;
      }

      this.$emit('documentClick', this);
      this.changeVisible(false);
    },

    elementContains(elm, otherElm) {
      if (typeof elm.contains === 'function') {
        return elm.contains(otherElm);
      }

      return false;
    },

    getPopperConfig() {
      var self = this;
      var config = (0, _merge.default)({
        onCreate(data) {
          data.instance.popper.style.zIndex = self.zIndex;
          self.$emit('create', data);
        },

        onUpdate(data) {
          if (self.isShowPopper) {
            data.instance.popper.style.zIndex = self.zIndex;
          }
        }

      }, {
        modifiers: {
          offset: {
            offset: 0
          },
          preventOverflow: {
            padding: 0
          }
        }
      }, {
        placement: this.placement,
        positionFixed: this.fixed,
        eventsEnabled: true,
        removeOnDestroy: false,
        modifiers: this.modifiers
      });
      return config;
    },

    createPopper() {
      if (!this.$el || !this.$refs.content) return;

      if (this[popperJs]) {
        this[popperJs].destroy();
      }

      this[popperJs] = new _popper.default(this.$el, this.$refs.content, this.getPopperConfig());

      if (this.appendToBody && !this.appendedToBody) {
        this.appendedToBody = true;
        document.body.appendChild(this.$refs.content);
      }

      this.initPopperEvent();
    },

    updatePopper() {
      var _this3 = this;

      if (!this.isShowPopper) return;

      if (this[popperJs]) {
        this[popperJs].scheduleUpdate();
      } else {
        this.$nextTick(function () {
          _this3.createPopper();
        });
      }
    }

  }
};
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c(_vm.tag, _vm._g(_vm._b({
    tag: "span"
  }, "span", _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm._v(" "), _c("transition", _vm._g({
    attrs: {
      name: typeof _vm.animation === "string" ? _vm.animation : undefined
    },
    on: {
      "after-leave": _vm.afterLeave
    }
  }, typeof _vm.animation === "object" ? _vm.animation : undefined), [(_vm.lazy ? _vm.hasShow : true) ? _c("span", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isShowPopper,
      expression: "isShowPopper"
    }],
    ref: "content",
    class: [_vm.bem([_vm.theme, {
      arrow: _vm.arrow
    }]), _vm.popoverClass],
    style: {
      zIndex: _vm.zIndex
    }
  }, [[_vm._t("content"), _vm._v(" "), _vm.arrow ? _c("div", {
    class: _vm.bem("arrow"),
    attrs: {
      "x-arrow": ""
    }
  }) : _vm._e()]], 2) : _vm._e()])], 2);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

/* style inject */

/* style inject SSR */
var _default2 = (0, _vueNormalizeComponent.default)({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

exports.default = _default2;